import React from "react";

const ForgotPassword = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      ForgotPassword
    </div>
  );
};

export default ForgotPassword;
